export default "__VITE_ASSET__BBYOhXsW__"